import styled from "styled-components"
import media from "styled-media-query"
import { Link } from "gatsby"

export const Hero = styled.section`
  display: flex;
  flex-direction: column;
  flex-wrap: no-wrap;

  ${media.greaterThan("large")`
    flex-direction: row;
  `}
`

export const HeroContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

export const HeroItemShowcase = styled.div`
  height: 30em;
  margin: 1em 0;
  overflow: hidden;

  ${media.greaterThan("medium")`
    height: 40em;
    margin: 2em 0.3em 2em 0;
  `}

  div:first-of-type:hover {
    background: rgba(0, 0, 0, 0.3);
    transition: all 0.5s linear;
  }

  & a:first-child {
    height: 100%;
    width: 100%;
  }
`

export const HeroItem = styled.div`
  height: 25em;
  margin: 0;

  ${media.greaterThan("medium")`
    height: 40em;
    margin: 2em 0 2em 0.3em;
  `}

  div:hover {
    background: rgba(0, 0, 0, 0.3);
    transition: all 0.5s linear;
  }

  a {
    height: 10em;

    ${media.greaterThan("medium")`
      height: 19.75em;
    `}

    h1 {
      font-size: ${props => props.theme.fontSizes.h4};
      line-height: 1em;
      padding-bottom: 0.5em;

      ${media.greaterThan("medium")`
      font-size: ${props => props.theme.fontSizes.h3};
      `}
    }

    p {
      display: none;
    }
  }

  & a:first-child {
    margin-bottom: 1em;

    ${media.greaterThan("medium")`
      margin-bottom: 0.5em;
    `}
  }

  & a:nth-child(2) {
    margin-top: 0;
  }
`

export const HeroLink = styled(Link)`
  background: ${props =>
    props.image ? `url(${props.image}) no-repeat center` : "transparent"};
  background-size: cover;
  border-radius: 0.5em;
  color: white;
  display: flex;
  height: 100%;
  width: 100%;

  /* &:hover {
    opacity: 1;
  } */
`
export const HeroPostWrapper = styled.div`
  align-items: space-between;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.5em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;
  padding: 1em;
  width: 100%;
`

export const HeroPostInfo = styled.summary`
  max-width: 100%;

  span {
    font-size: ${props => props.theme.fontSizes.small};
    opacity: 0.9;
    text-transform: uppercase;
  }
`

export const HeroPostTitle = styled.h2`
  font-weight: bold;
  text-shadow: 1px 1px 0 black;
`
export const HeroPostDescription = styled.p`
  font-style: normal;
  text-shadow: 1px 1px 0 black;
`
